import { Search } from 'lucide-react';
import { FOCUS_RING_CLASSES } from '../lib/focusTrap';

interface HeaderProps {
  onMenuClick?: () => void;
  /** When true, shows the menu button (e.g. when user is authenticated and SideNav is available). */
  showMenuButton?: boolean;
  /** When set, shows the search button (opens the document search overlay). */
  onSearchClick?: () => void;
}

/** Top bar with the Alma wordmark, an optional menu button, and search. */
export function Header({ onMenuClick, showMenuButton = false, onSearchClick }: HeaderProps) {
  return (
    <header className="header-chrome z-30 transition-all duration-300 border-b border-[var(--card-border)]">
      <div className="w-full px-4 sm:px-6 lg:px-12 xl:px-16 py-3 flex items-center justify-between">
        <div className="flex items-center gap-4">
          {showMenuButton && (
            <button
              type="button"
              onClick={onMenuClick}
              className={`lg:hidden inline-flex min-h-11 min-w-11 items-center justify-center p-2 hover:bg-[color-mix(in_oklab,var(--text-primary)_7%,transparent)] rounded-xl transition-colors ${FOCUS_RING_CLASSES}`}
              aria-label="Menu"
            >
              <svg
                className="w-6 h-6 text-[var(--accent-ink)]"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden
              >
                <path d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          )}
          <span className="text-xl font-bold text-[var(--accent-ink)]">Alma</span>
        </div>

        {onSearchClick && (
          <button
            type="button"
            onClick={onSearchClick}
            className={`inline-flex min-h-11 min-w-11 items-center justify-center p-2 hover:bg-[color-mix(in_oklab,var(--text-primary)_7%,transparent)] rounded-xl transition-colors ${FOCUS_RING_CLASSES}`}
            aria-label="Search your documents"
          >
            <Search className="w-5 h-5 text-[var(--text-secondary)]" aria-hidden />
          </button>
        )}
      </div>
    </header>
  );
}
